import React, { Component } from 'react';
import ErrorGeneral from './ErrorGeneral';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      errorMessage: ''
    };
  }

  componentDidCatch(error) {
    this.setState({
      hasError: true,
      errorMessage: error.message
    });
  }

  render() {
    // eslint-disable-next-line react/destructuring-assignment
    if (this.state.hasError) {
      return <ErrorGeneral errorMessage={this.state.errorMessage} />;
    }
    // eslint-disable-next-line react/destructuring-assignment,react/prop-types
    return this.props.children;
  }
}

export default ErrorBoundary;
